import './InfoTooltip.scss';

import { CloseCircleOutlined, InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

interface InfoTooltipProps {
  tooltipText: string;
  type?: 'info' | 'warning' | 'error';
  iconClassName?: string;
  iconStyle?: React.CSSProperties;
}

const InfoTooltip = (props: InfoTooltipProps) => {
  const { tooltipText, type = 'info', iconClassName = '', iconStyle } = props;

  return (
    <Tooltip className="InfoTooltip" title={tooltipText}>
      {type === 'info' && (
        <InfoCircleOutlined className={`InfoTooltipIcon ${iconClassName}`} style={iconStyle} />
      )}
      {type === 'warning' && (
        <WarningOutlined className={`InfoTooltipIcon Warning ${iconClassName}`} style={iconStyle} />
      )}
      {type === 'error' && (
        <CloseCircleOutlined
          className={`InfoTooltipIcon Error ${iconClassName}`}
          style={iconStyle}
        />
      )}
    </Tooltip>
  );
};

export default InfoTooltip;
